import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Stack, Typography } from '@mui/material';
import { StepBox } from '@/components/layout/step-box';
import { Flow } from '@/constants/flow';
import { useBizState } from '@/hooks/use-biz-state';
import { useCoreRequest } from '@/hooks/use-core-request';
import { useFlow } from '@/hooks/use-flow';
import { AppCoreContext } from '@/providers/core-provider';

export const StepRoamGrant: React.FC = () => {
  const { t } = useTranslation();
  const { lenovoId } = useContext(AppCoreContext);
  const { userName, areaCode, tempCode } = useBizState();
  const { setFlow } = useFlow();
  const { run, loading: requesting } = useCoreRequest(() => lenovoId.roamGrant({ userName, areaCode, tempCode }), {
    manual: true,
    onSuccess: ({ nextSteps }) => {
      if (nextSteps === Flow.LOGIN_STEP_INPUT_PASSWORD) {
        setFlow(Flow.LOGIN_STEP_INPUT_PASSWORD);
        return;
      }
      setFlow(Flow.EXCEPTION_SOMETHING_WENT_WRONG);
    },
  });

  return (
    <StepBox
      title={t('cross_region_consent_title')}
      backButtonProps={{
        disabled: requesting,
      }}
      backFlow={Flow.LOGIN_STEP_INPUT_USERNAME}
    >
      <Stack spacing={2}>
        <Typography>{t('cross_region_consent_description')}</Typography>
        <Button variant="contained" loading={requesting} onClick={run}>
          {t('agree')}
        </Button>
      </Stack>
    </StepBox>
  );
};
